// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import Alert from 'react-s-alert';

import XDialog from './XDialog.jsx';
import PreviewCfgEscala from './PreviewCfgEscala.jsx';
import EscalaLyr from './EscalaLyr.jsx';
import TablaEscala from './TablaEscala.jsx';
import EscalaDiff from './EscalaDiff.jsx';
import App from './App.jsx';

import {takeDir, gen_snum, add_port} from './utils.js';
import {fetch_escalas_lyr} from './fetch_things.js';
import {get_stats_limits} from './show_stats.js';
import {find_escala_lyr} from './types.js';
import {get_lyrs_of} from './image_mix.js';

import type {T_ReporteEscalasLyr, T_EscalaLyr} from './types.js';
import type {T_ReadEscala} from './TablaEscala.jsx';

import './css/Escala.css';

const S = require('underscore.string');




function read_escala(name_escala: string, html: string): T_ReadEscala {   // FIXME: REMUEVE EL SOPORTE PARA ESTA CLASE DE ESCALAS.
  const $e     = $(html),
        center = $e.first(),
        elem   = center.find('b').text();
  
  return {
    elem,
    unit: S.trim(center.text().slice(elem.length)),
    rows: $e.last().find('tr').map((ii, str) => {
      const tr = $(str),
            bg = $(tr.find('td.escala-tifrow')[0]).css('backgroundColor');
      
      return {
        color: bg,
        range: S.trim(tr.text()).split('-')
      };
    }).get(),
    name_escala,
    smile_on: NaN,
    lim     : null,
    snum    : gen_snum(2)
  };
}



type T_TMAP_JSON = {
  esc_family: string,
  esc_ncolor: number,
  esc_invert: boolean
};



export type T_Escala = {       // NOTE: HAY MÁS PROPIEDADES QUE DEVUELVE EL SERVICIO img-scale/, PERO ESTAS USO.
  pathScale : string,          // URL de la escala png, si existe (sorry por ponerle pathScale, pero es una URL).
  html      : string,          // 
  img       : string,          // full path del mapa png
  file      : string,          // filename  del mapa png
  elem      : string,          // nombre del elemento del mapa
  tmap_json?: T_TMAP_JSON,     // detalles de la escala de un mapa temático.
  lyrPath   : string,          // podría ser ''
  f1        : string,          // posible path de la escala en la misma carpeta que la imagen
  ex1       : boolean,         // existe f1? La escala puede vivir en f1 o f2.
  f2        : string,          // posible path de la escala en /app/data/escalas
  ex2       : boolean,         // existe f2?
  limPath   : string,          // posible path del archivo .lim, que tiene una sola línea, con los límites de la escala.
  exlim     : boolean,         // existe el archivo .lim?
  gmax?     : number           // presente sólo en los diff. gmax señala que la escala de colores debe ir desde -gmax a gmax.
};



export function get_path_escala(esc: T_Escala): string {
  if (esc.ex1) {
    return esc.f1;
  }
  
  if (esc.ex2) {
    return esc.f2;
  }
  
  return '/app/data/escalas/la_escala_no_existe.png';
}



type T_EscalaProps = {
  escala_for      : string,
  window_drag     : boolean,
  dev_mode        : boolean,
  esc             : T_Escala,
  lyr             : ?T_EscalaLyr,
  frame_drag?     : boolean,
  no_close?       : boolean,
  toggleable?     : boolean,    // NOTE: por el momento, esta propiedad se respeta sólo en el caso de que frame_drag = false.
  use_color_brewer: boolean,
  app             : App
};



type T_EscalaState = {
  escala : ?T_Escala,
  lyr    : ?T_EscalaLyr,
  lim    : ?[number, number],
  toggled: boolean
};




export default class Escala extends Component<T_EscalaProps, T_EscalaState> {
  abort    : boolean;
  escala_mt: ?PreviewCfgEscala;
  
  toggle: () => void;
  
  
  
  constructor(props: T_EscalaProps) {
    super(props);
    
    this.state  = {
      escala : props.esc,
      lyr    : props.lyr ? props.lyr : null,
      lim    : null,
      toggled: false
    };
    
    this.escala_mt = null;
    
    this.toggle = this.toggle.bind(this);
    
    this.abort = false;
  }
  
  
  
  toggle(): void {
    if (this.props.toggleable) {
      this.setState({toggled: ! this.state.toggled});
    }
  }
  
  
  
  get_lyr_lims = (): void => {
    get_lyrs_of(this.props.app, [this.props.escala_for], (lyrs: Array<?T_EscalaLyr>): void => {
      if (lyrs.length > 0 && lyrs[0] != null) {
        this.setState({lyr: lyrs[0]});
      }
      else {
        Alert.error('No pude encontrar los límites de la escala.');
      }
    });
  };
  
  
  
  render() {                     // NOTE: this.state.lim se refiere a los límites min max de los pixeles del raster
    if (this.state.escala) {     // del elemento actual (min max de los stats). Nada que ver con los límites de la escala.
      const sty     = {backgroundColor: 'white'},
            {app}   = this.props,
            snum    = gen_snum(app.state.num_decimals),
            is_prod = app.state.user.role.indexOf('Produccion') === 0 || app.dev_mode,
            lyr_0   = (this.state.lyr && this.state.lyr.elemRange) ? this.state.lyr.elemRange[0] : -1,
            lyr_1   = (this.state.lyr && this.state.lyr.elemRange) ? this.state.lyr.elemRange[1] : -2;
      
      const content = (
        (this.state.escala && this.state.escala.html && this.state.escala.html !== 'NO') ?
          <TablaEscala {...read_escala(app.state.name_escala, this.state.escala.html)} />
        :
          ((this.state.escala && this.state.escala.tmap_json) ?
            <PreviewCfgEscala
              num_colors={this.state.escala.tmap_json.esc_ncolor}
              name_escala={this.state.escala.tmap_json.esc_family}
              inv_escala={this.state.escala.tmap_json.esc_invert}
              style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, width: 70}}
              father={this}
              ref={comp => this.escala_mt = comp}
            />
          :
            ((this.props.dev_mode && this.props.use_color_brewer && this.state.lyr) ?
              <EscalaLyr
                lyr={this.state.lyr}
                lim={this.state.lim}
                name_escala={app.state.name_escala}
                num_colors={app.state.num_colors_escala}
                inv_brewer={app.state.inv_escala}
                num_decimals={app.state.num_decimals}
                png_path={this.props.escala_for}
                app={this.props.app}
              />
            :
              ((this.state.escala && this.state.escala.gmax && typeof this.state.escala.gmax === 'number') ?
                <EscalaDiff
                  gmax={this.state.escala.gmax}
                />
              :
                (this.state.escala &&
                  <div>
                    <img src={add_port(this.state.escala.pathScale)} alt='escala' />
                    
                    {is_prod &&
                      <div className='esc_vis_lim'>
                        {(lyr_0 > 0 || lyr_1 > 0) ?
                          (`Lyr: ${snum(lyr_0)} - ${snum(lyr_1)}`)
                         :
                          <button onClick={this.get_lyr_lims}>
                            Obtener límites
                          </button>
                        }
                      </div>
                    }
                  </div>
                )
              )
            )
          )
      );
      
      return (
        (_.has(this.props, 'frame_drag') && ! this.props.frame_drag) ?
          <div className='escala_for' style={sty}>
            <p className='dtitle' onDoubleClick={this.toggle}>
              Escala &nbsp;
            </p>

            {(! this.state.toggled) &&
              content
            }
          </div>
        :
          <XDialog
            name='escala_for'
            title='Escala'
            father={app.map_ui}
            drag={false}
            style={sty}
            frame_drag={true}
            no_close={this.props.no_close}
            toggleable={this.props.toggleable}
            children={content}
            font={app.favorite_font()}
          />
      );
    }
    else {
      return null;
    }
  }
  
  
  
  load(): void {
    if (! this.props.escala_for) {
      return;
    }
    
    const {app} = this.props,
          dir   = takeDir(this.props.escala_for),
          culti = app.map_ui.map.get_culti_of(dir);
    
    if (! culti) {       // la escala murió, probablemente porque
      return;            //  cambiamos de four_maps a uno solo.
    }
    
    if (this.state.escala != null && this.state.lyr != null) {
      get_stats_limits(app, culti, () => {
        const lim = app.map_ui.get_limits_of(this.props.escala_for);
        
        if (this != null) {
          this.setState({lim});
        }
      });
      
      return;
    }
    
    const url = `${app.remote}/img-scale/?path=${this.props.escala_for}&session_id=${app.session()}&host=${app.props.domain}`;
    
    fetch(url).then(resp => resp.json()).then((escala: T_Escala) => {
      if (! this.abort) {
        if (! _.has(app.map_ui.Lyr_List, dir)) {
          fetch_escalas_lyr(app, dir, (result) => {
            let lyr = null,
                lim = null;
            
            if (typeof result !== 'string') {
              const report = (result : T_ReporteEscalasLyr);
              
              lyr = find_escala_lyr(report, this.props.escala_for);
              
              app.map_ui.Lyr_List[dir] = report;
              
              get_stats_limits(app, culti, () => {
                lim = app.map_ui.get_limits_of(this.props.escala_for);
                
                this.setState({escala, lyr, lim});
              });
            }
            else {
              this.setState({escala, lyr, lim});
            }
          });
        }
        else {
          const report = app.map_ui.Lyr_List[dir],
                lyr    = find_escala_lyr(report, this.props.escala_for);
          
          get_stats_limits(app, culti, () => {
            this.setState({escala, lyr, lim: app.map_ui.get_limits_of(this.props.escala_for)});
          });
        }
      }
    });
  }
  
  
  
  componentWillUnmount() {
    this.abort = true;
    
    this.props.app.map_ui.escala = null;
  }
  
  
  
  componentDidUpdate(prevProps: T_EscalaProps, prevState: T_EscalaState) {
    if (this.props.escala_for !== prevProps.escala_for) {
      this.load();
    }
  }
  
  
  
  componentDidMount() {
    this.load();
  }
}



// WEBPACK FOOTER //
// ./src/Escala.jsx